import React, { Component } from 'react';
import styled from 'styled-components';
import Header from '../../shared/Header';
import {
  Column,
  Title,
  Button,
  StyledSelect,
  Label,
  StyledRow,
  Form,
  Text,
} from '../../theme/index';
import { Formik } from 'formik';
import ImageLoader from '../../shared/ImageLoader';

const StyledColumn = styled(Column)`
  align-items: center;
  text-align: ${props => props.textalign};
  width: 75%;
  margin: 0 auto;
  padding: 1em 0;
  @media (max-width: 400px) {
    width: 90%;
  }
`;

export default class DentistrySplash extends Component {
  state = {
    profession: [
      { label: 'Dentist', value: 'dentist' },
      { label: 'Dental Hygienist', value: 'dentalHygienist' },
      {
        label: 'Registered Dental Assistant',
        value: 'registeredDentalAssistant',
      },
    ],
  };

  render() {
    const { img, id, navigate } = this.props;
    const { profession } = this.state;
    return (
      <ImageLoader src={img} id={id}>
        <Header />
        <StyledColumn textalign={id === 'home' ? 'left' : 'center'}>
          <Title orange small margin="0">
            Convenient + Affordable
          </Title>
          <Title white margin=".25em 0 0 0">
            California Online Dental CE
          </Title>
          <Text white margin="1.75em 0 0 0">
            Choose your dentistry profession
          </Text>
          <Formik
            initialValues={{ profession: '' }}
            onSubmit={values => {
              let profession = values.profession.label.replace(/\s+/g, '-');
              navigate.push(`/${profession}/California`);
            }}
            render={({ values, handleBlur, handleSubmit, setFieldValue }) => (
              <Form onSubmit={handleSubmit}>
                <StyledRow>
                  <Label htmlFor="profession">
                    <StyledSelect
                      required
                      type="profession"
                      id="profession"
                      placeholder="Profession"
                      options={profession}
                      onChange={value => {
                        setFieldValue('profession', value);
                      }}
                      onBlur={handleBlur}
                      value={values.profession}
                    />
                  </Label>
                </StyledRow>
                <Button home type="submit">
                  Find your ce
                </Button>
              </Form>
            )}
          />
        </StyledColumn>
      </ImageLoader>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/screens/Industry/DentistrySplash.jsx